export const createTokenManager = (storageKey = null) => {
	let localStorageKey = storageKey;
	let jwtToken = null;
	let refreshToken = null;

	const setLocalStorageKey = key => {
		if (localStorageKey !== null && localStorageKey !== key) {
			clearTokens();
		}
		localStorageKey = key || null;
	};

	const getToken = () => jwtToken;
	const setToken = token => {
		jwtToken = token;
	};

	const getRefreshToken = () => (localStorageKey !== null ? window.localStorage.getItem(localStorageKey) : refreshToken);

	const setRefreshToken = token => {
		if (localStorageKey !== null) {
			window.localStorage.setItem(localStorageKey, token);
		} else {
			refreshToken = token;
		}
	};

	const clearTokens = () => {
		jwtToken = null;
		refreshToken = null;
		window.localStorage.removeItem(localStorageKey);
	};

	return {
		setLocalStorageKey,
		getToken,
		setToken,
		getRefreshToken,
		setRefreshToken,
		clearTokens
	};
};

export default createTokenManager();
